import { useAppDispatch } from "app/hooks";
import {
  addRecentInvoice,
  clearRecentInvoices,
  setRefreshRecentInvoices,
  toggleShowRecentInvoices,
} from "features/billing/invoices/billing-filters-slice";
import useSyncBetweenTabs, {
  appInstanceId,
  type SyncMessage,
} from "hooks/use-sync-between-tabs.hook";
import { memo, useCallback, useRef } from "react";
const TabSyncMessagesListener = () => {
  const processedMessageIds = useRef(new Set<string>());
  const dispatch = useAppDispatch();

  const handleMessage = useCallback(
    (params: SyncMessage) => {
      const { emitterId, action, payload } = params;
      if (emitterId === appInstanceId) return;
      if (action === "addRecentInvoice") {
        dispatch(
          addRecentInvoice({
            saleId: payload.saleId,
            patientId: payload.patientId,
            practiceId: payload.practiceId,
            doNotSendSyncMessage: true,
          })
        );
      } else if (action === "toggleShowRecentInvoices") {
        dispatch(
          toggleShowRecentInvoices({
            value: payload.value,
            doNotSendSyncMessage: true,
          })
        );
      } else if (action === "clearRecentInvoices") {
        dispatch(
          clearRecentInvoices({
            practiceId: payload.practiceId,
            doNotSendSyncMessage: true,
          })
        );
      } else if (action === "setRefreshRecentInvoices") {
        dispatch(
          setRefreshRecentInvoices({
            refreshRecentInvoices: payload.refreshRecentInvoices,
            doNotSendSyncMessage: true,
          })
        );
      }
    },
    [dispatch]
  );

  useSyncBetweenTabs<{ action: string; payload: any }>(
    processedMessageIds,
    handleMessage
  );

  return null;
};

export default memo(TabSyncMessagesListener);
